// Slice 13 — el header de la tienda publica su alto real en una variable CSS
// (--sf-header-offset) para que lo usen el toast y lo que se pegue arriba.
// Antes el toast usaba 6rem fijo y quedaba encima del header (que mide más
// con la franja de categorías o el mensaje superior).

export const HEADER_OFFSET_VAR = "--sf-header-offset";

/** Offset visible del header: 0 si se ocultó al hacer scroll. */
export function headerOffsetPx(heightPx: number, hidden: boolean): string {
  if (hidden || !Number.isFinite(heightPx) || heightPx <= 0) return "0px";
  return `${Math.round(heightPx)}px`;
}
